import withAuthHeader from '../../utils/withAuthHeader'
import checkAuthorizationError from '../../utils/checkAuthorizationError';

import { mapFetchDashboardDataRequest, mapFetchSimpleInfoResponse, mapFetchDailyHistoryChartResponse, mapFetchBarChartResponse, mapFetchHeatMapResponse, mapFetchPieChartResponse, mapFetchReviews, mapFetchProductsRanking, mapFetchClientsRanking } from '../mappers/dashboard'

export const fetchSimpleInfo = (filterDates) => async (dispatch, getState, api) => {
    let result = {}
    try {
        
        const url = `api/v1/dashboard/resumo`;
        const apiResponse = await dispatch(fetchDashboardData({ url, filterDates }))

        const response = mapFetchSimpleInfoResponse(apiResponse.data);
        result = {
            success: true,
            data: response
        }
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}


export const fetchOrdersHistory = (filterDates) => async (dispatch, getState, api) => {
    let result = {}
    try {
        const url = `api/v1/dashboard/historicopedido`;
        const apiResponse = await dispatch(fetchDashboardData({ url, filterDates }))
        const response = mapFetchBarChartResponse(apiResponse.data);
        result = {
            success: true,
            data: response
        }
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}

export const fetchRevenueHistory = (filterDates) => async (dispatch, getState, api) => {
    let result = {}
    try {
        const url = `api/v1/dashboard/historicofaturamento`;
        const apiResponse = await dispatch(fetchDashboardData({ url, filterDates }))
        const response = mapFetchBarChartResponse(apiResponse.data);
        result = {
            success: true,
            data: response
        }
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}

export const fetchDailyHistory = (filterDates) => async (dispatch, getState, api) => {
    let result = {}
    try {
        const url = `api/v1/dashboard/historicodiario`;
        const apiResponse = await dispatch(fetchDashboardData({ url, filterDates }))
        const response = mapFetchDailyHistoryChartResponse(apiResponse.data);
        result = {
            success: true,
            data: response
        }
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}

export const fetchUserRecurrence = (filterDates) => async (dispatch, getState, api) => {
    let result = {}
    try {
        const url = `api/v1/dashboard/recorrenciausuarios`;
        const apiResponse = await dispatch(fetchDashboardData({ url, filterDates }))
        const response = mapFetchPieChartResponse(apiResponse.data);
        result = {
            success: true,
            data: response
        }
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}

export const fetchPaymentMethods = (filterDates) => async (dispatch, getState, api) => {
    let result = {}
    try {
        const url = `api/v1/dashboard/formasdepagamento`;
        const apiResponse = await dispatch(fetchDashboardData({ url, filterDates }))
        const response = mapFetchPieChartResponse(apiResponse.data);
        result = {
            success: true,
            data: response
        }
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}

export const fetchOrderKind = (filterDates) => async (dispatch, getState, api) => {
    let result = {}
    try {
        const url = `api/v1/dashboard/modalidadepedido`;
        const apiResponse = await dispatch(fetchDashboardData({ url, filterDates }))
        const response = mapFetchPieChartResponse(apiResponse.data);
        result = {
            success: true,
            data: response
        }
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}

export const fetchSaleChannels = (filterDates) => async (dispatch, getState, api) => {
    let result = {}
    try {
        const url = `api/v1/dashboard/canaldevenda`;
        const apiResponse = await dispatch(fetchDashboardData({ url, filterDates }))
        const response = mapFetchPieChartResponse(apiResponse.data);
        result = {
            success: true,
            data: response
        }
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}

export const fetchHeatMap = (filterDates) => async (dispatch, getState, api) => {
    let result = {}
    try {
        const url = `api/v1/dashboard/mapacalor`;
        const apiResponse = await dispatch(fetchDashboardData({ url, filterDates }))
        const response = mapFetchHeatMapResponse(apiResponse.data);
        result = {
            success: true,
            data: response
        }
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}

export const fetchPostSaleInfo = (filterDates) => async (dispatch, getState, api) => {
    let result = {}
    try {
        const url = `api/v1/dashboard/resumoposvenda`;
        const apiResponse = await dispatch(fetchDashboardData({ url, filterDates }))
        const response = mapFetchSimpleInfoResponse(apiResponse.data);
        result = {
            success: true,
            data: response
        }
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}

export const fetchReviews = (filterDates) => async (dispatch, getState, api) => {
    let result = {}
    try {
        const url = `api/v1/dashboard/avaliacoes`;
        const apiResponse = await dispatch(fetchDashboardData({ url, filterDates }))
        const response = mapFetchReviews(apiResponse.data);
        result = {
            success: true,
            data: response
        }
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}

export const fetchProductsRanking = (filterDates) => async (dispatch, getState, api) => {
    let result = {}
    try {
        const url = `api/v1/dashboard/rankprodutos`;
        const apiResponse = await dispatch(fetchDashboardData({ url, filterDates }))
        const response = mapFetchProductsRanking(apiResponse.data);
        result = {
            success: true,
            data: response
        }
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}

export const fetchClientsRanking = (filterDates) => async (dispatch, getState, api) => {
    let result = {}
    try {
        const url = `api/v1/dashboard/rankusuarios`;
        const apiResponse = await dispatch(fetchDashboardData({ url, filterDates }))
        const response = mapFetchClientsRanking(apiResponse.data);
        result = {
            success: true,
            data: response
        }
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}


export const fetchDashboardData = ({ url, filterDates }) => async (dispatch, getState, api) => {
    const body = mapFetchDashboardDataRequest({
        initialDate: filterDates.initial,
        finalDate: filterDates.final,
        storeId: filterDates.storeId || undefined
    })
    const apiResponse = await api.get(url, {
        params: body,
        ...withAuthHeader()
    });
    return apiResponse
}
